import React from 'react';
import { Navigate } from 'react-router-dom';


const AccountSettings = React.lazy(() => import('../pages/SettingsViews/AccountSettings.js'));
const PersonaliseSettings = React.lazy(() => import('../pages/SettingsViews/PersonaliseSettings.js'));
const APISettings = React.lazy(() => import('../pages/SettingsViews/APISettings.js'));
const SubscriptionSettings = React.lazy(() => import('../pages/SettingsViews/SubscriptionSettings.js'));

const SettingsRoutes = [
    { path: 'account', element: <AccountSettings /> },
    { path: 'personalise', element: <PersonaliseSettings /> },
    { path: 'api', element: <APISettings /> },
    { path: 'subscription', element: <SubscriptionSettings /> },
    { path: '*', element: <Navigate to="/" replace /> } // redirect fallback
];

export default SettingsRoutes;
